module.exports = __webpack_public_path__ + "static/media/branding-colors.a732e03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding-colors.png
// module id = 1301
// module chunks = 0